'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var TabPanel = require('./TabPanel.js');
var TabNav = require('./TabNav.js');
var Tabs = require('./Tabs.js');
var Tab = require('./Tab.js');

var SimpleTabs = function (props) {
    var defaultActive = props.defaultActive, schema = props.schema;
    var _a = react.useState(defaultActive), active = _a[0], setActive = _a[1];
    var handleChange = function (id) {
        setActive(id);
    };
    return (jsxRuntime.jsxs(Tabs.Tabs, tslib.__assign({ active: active, onChange: handleChange }, { children: [jsxRuntime.jsx(TabNav.TabNav, { children: schema.map(function (item) { return (jsxRuntime.jsx(Tab.Tab, tslib.__assign({ id: item.id }, { children: item.title }), item.id)); }) }), schema.map(function (item) { return (jsxRuntime.jsx(TabPanel.TabPanel, tslib.__assign({ tabId: item.id }, { children: item.content }), item.id)); })] })));
};

exports.SimpleTabs = SimpleTabs;
//# sourceMappingURL=SimpleTabs.js.map
